import React from 'react';
import language from '../../config/es';
import { Spinner, Col } from 'react-bootstrap';
const LabelChargeData = (props) => {
  const { showloading = false ,size='sm',label=language.messages.lblLoading} = props;
  return (
    <Col
      md={12}
      className="text-start small text-primary ms-2"
       style={{
         display: !showloading ? '' : 'none',
      }}
    >
      {label}{' '}
      <Spinner  animation="border" color="secundary" size={size} />
    </Col>
  );
};
export default LabelChargeData;
